import * as THREE from "three";
// import * as dat from "lil-gui";
import { OBJLoader } from "three/addons/loaders/OBJLoader.js";

/**
 * Debug
 */
// const gui = new dat.GUI();

// const parameters = {
//   materialColor: "#7653a2",
// };

// gui.addColor(parameters, "materialColor").onChange(() => {
//   material.color.set(parameters.materialColor);
// });

/**
 * Base
 */
// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Objects
 * */

// Create a loader for the OBJ file
var loader = new OBJLoader();
var textureLoader = new THREE.TextureLoader();
let pear;

// Particles
const particlesCount = 750;
const positions = new Float32Array(particlesCount * 3);
const pointSizes = new Float32Array(particlesCount * 3);

for (let i = 0; i < particlesCount * 3; i++) {
  positions[i * 3 + 0] = (Math.random() - 0.5) * 3.5 + 0.2;
  positions[i * 3 + 1] = (Math.random() - 0.5) * 10;
  positions[i * 3 + 2] = (Math.random() - 0.5) * 10;

  pointSizes[i] = Math.random() * 1 - 0.5;
}

const geometry = new THREE.BufferGeometry();
geometry.setAttribute(
  "position",
  new THREE.Float32BufferAttribute(positions, 3)
);
geometry.setAttribute("size", new THREE.Float32BufferAttribute(pointSizes, 1));
geometry.setAttribute("position", new THREE.BufferAttribute(positions, 3));

// Material
const particlesMaterial = new THREE.PointsMaterial();

// Function to calculate responsive particle size
const getParticleSize = () => {
  // Base size for desktop (1920px width)
  const baseSize = 0.04;
  const baseWidth = 1920;

  // Scale particles up for smaller screens (mobile)
  // Min size 0.06 for mobile, max 0.08 for very small screens
  const scaleFactor = Math.max(1, baseWidth / window.innerWidth);
  return Math.min(baseSize * scaleFactor * 1.5, 0.08);
};

particlesMaterial.size = getParticleSize();
particlesMaterial.sizeAttenuation = true;

particlesMaterial.color = new THREE.Color("#fff7e6");

particlesMaterial.transparent = true;
particlesMaterial.alphaMap = textureLoader.load("textures/dust.png");
particlesMaterial.depthWrite = false;
particlesMaterial.blending = THREE.AdditiveBlending;

const particles = new THREE.Points(geometry, particlesMaterial);
scene.add(particles);

// Pear
// Load the OBJ file
loader.load(
  "obj/PrickleyPear.obj",
  function (object) {
    var normalMap = textureLoader.load("textures/nmap.jpg");
    var roughnessMap = textureLoader.load("textures/roughness.jpg");
    var specularMap = textureLoader.load("textures/spec.jpg");
    var texture = textureLoader.load("textures/texture.jpg");

    pear = object;
    pear.scale.set(20, 20, 20);
    pear.rotation.set(1, 0.5, 0.5);

    // Create material using the maps
    var material = new THREE.MeshPhysicalMaterial({
      normalMap: normalMap,
      roughnessMap: roughnessMap,
      specularMap: specularMap,
      map: texture,
      sheen: 1.0,
      wireframe: false,
    });
    pear.material = material;

    // Apply the material to the loaded object
    object.traverse(function (child) {
      if (child instanceof THREE.Mesh) {
        child.material = material;
      }
    });

    scene.add(pear);
  },
  function (xhr) {
    console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
  },
  function (error) {
    console.log("An error occurred while loading the OBJ file");
  }
);

// Background
let background;
const backgroundTexture = textureLoader.load("textures/kitchen.png");
const createBackground = () => {
  // Calculate the visible dimensions at the background's distance from camera
  const distance = 16; // Camera is at z=6, background at z=-10, so distance is 16
  const fov = 35 * (Math.PI / 180); // Convert to radians
  const viewportAspect = window.innerWidth / window.innerHeight;

  // Calculate visible height and width at the background plane
  const visibleHeight = 2 * Math.tan(fov / 2) * distance;
  const visibleWidth = visibleHeight * viewportAspect;

  // Assume background image is roughly square or use 1:1 aspect ratio
  // Adjust this if you know the actual aspect ratio of kitchen.png
  const imageAspect = 1; // Change this to match your actual image aspect ratio

  // Calculate size to cover viewport while maintaining image aspect ratio
  // Similar to CSS background-size: cover
  let planeWidth, planeHeight;

  if (viewportAspect > imageAspect) {
    // Viewport is wider than image - fit to width
    planeWidth = visibleWidth * 1.2; // 1.2x for margin
    planeHeight = planeWidth / imageAspect;
  } else {
    // Viewport is taller than image - fit to height
    planeHeight = visibleHeight * 1.2; // 1.2x for margin
    planeWidth = planeHeight * imageAspect;
  }

  if (background) {
    scene.remove(background);
    background.geometry.dispose();
  }

  background = new THREE.Mesh(
    new THREE.PlaneGeometry(planeWidth, planeHeight),
    new THREE.MeshBasicMaterial({
      map: backgroundTexture,
    })
  );
  background.position.z = -10;
  scene.add(background);
};

createBackground();

// Lights
const sunLight = new THREE.DirectionalLight("#ffffff", 1.5);
sunLight.position.set(0, 1, -4);
sunLight.castShadow = true;
scene.add(sunLight);

const roofLight = new THREE.DirectionalLight("#ffffff", 0.4);
roofLight.position.set(0, 3, -4);
roofLight.castShadow = true;
scene.add(roofLight);

const floorLight = new THREE.DirectionalLight("#f8e4bb", 0.3);
floorLight.position.set(0, -2, -3);
floorLight.lookAt(0, 0, 0);
floorLight.castShadow = true;
scene.add(floorLight);

// const ambientLight = new THREE.AmbientLight("#ffffff", 0.2);
// scene.add(ambientLight);

const hemisphereLight = new THREE.HemisphereLight("#ffffff", "#752f13", 0.7);
scene.add(hemisphereLight);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  // Update background
  createBackground();

  // Update particle size for current screen
  particlesMaterial.size = getParticleSize();
});

/**
 * Camera
 */
// Group
const cameraGroup = new THREE.Group();
scene.add(cameraGroup);

// Base camera
const camera = new THREE.PerspectiveCamera(
  35,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.z = 6;
cameraGroup.add(camera);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

document.addEventListener("keydown", (event) => {
  if (event.key === "x") {
    pear.rotation.x += 0.1;
    pear.material.wireframe = !pear.material.wireframe;
  }
});

// Scroll
document.addEventListener("wheel", (event) => {
  if (pear) {
    // if event.deltaY is positive, increase scale, else decrease scale
    if (event.deltaY > 0) {
      pear.scale.x += 0.1;
      pear.scale.y += 0.1;
      pear.scale.z += 0.1;
    } else {
      pear.scale.x -= 0.1;
      pear.scale.y -= 0.1;
      pear.scale.z -= 0.1;
    }
  }
});

// Cursor
const cursor = {
  x: 0,
  y: 0,
};
window.addEventListener("mousemove", (event) => {
  cursor.x = event.clientX / sizes.width - 0.5;
  cursor.y = event.clientY / sizes.height - 0.5;
});

/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  // animate the pear
  if (pear) {
    pear.rotation.x -= deltaTime * 0.12;
    pear.rotation.y += deltaTime * 0.1;
    pear.rotation.z += deltaTime * 0.08;
  }

  //   animate camera
  const parallaxX = cursor.x;
  const parallaxY = -cursor.y;

  cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 0.1;
  cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 0.1;

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
